<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'folder.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Category <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="remove()" class="bt-primary bt-delete" v-if="resource.id"><span><icon name="trash-01"/></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                        <notice-published v-model="resource" label-published="Cette catégorie est active." label-unpublished="Cette catégorie est inactive." :dates="false"></notice-published>
                    </header>

                    <main>

                        <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail de la catégorie</h3>
                                <p class="headline"></p>

                                <form-file label="Image" v-model="resource.picture_id" width="300"></form-file>

                                <form-text label="Slug" v-model="resource.slug" :required="true"></form-text>

                                <form-toggle label="Afficher dans la navigation du site" v-model="resource.is_visible"></form-toggle>

                                <form-toggle label="Assigner en tant que racine" v-model="resource.is_root"></form-toggle>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text  :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'headline'" :translations="resource.translations" :lang="client.id" :label="'Headline'" v-model="resource.translations[client.id].headline"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-html :translate-key="'description'" :translations="resource.translations"  label="Description" v-model="resource.translations[client.id].description" :lang="client.id"></form-html>
                                  </div>
                                </div>

                                <form-select label="Sort by default" multiple="false" v-model="resource.pagination_order" :default="resource.pagination_order" :options="paginationOrders"></form-select>

                                <component-attributes v-model="resource" :locale="locale"></component-attributes>

                              </fieldset>

                              <fieldset>
                                <h3>Attributs de recherche</h3>
                                <p class="headline">Les attributs sélectionnés apparaitront dans la recherche et les filtres de cette catégorie</p>

                                <form-select multiple="true" v-model="selection" id="id" :options="attributes" v-if="selection || attributes"></form-select>

                              </fieldset>
                            </tab>
                            <tab name="Seo">

                              <fieldset>
                                <h3>SEO</h3>
                                <p class="headline">Optimiser l'affichage de votre produit dans la recherche Google.</p>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :lang="client.id" :label="'Url'" v-model="resource.translations[client.id].meta_url"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :lang="client.id" :label="'Meta-Title'" v-model="resource.translations[client.id].meta_title"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-textarea :lang="client.id" :label="'Meta-Description'" v-model="resource.translations[client.id].meta_description"></form-textarea>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import CategoryService from './CategoryService.js';
    import AttributeService from '../../config/attribute/AttributeService.js';
    import Edit from '../../../layouts/Edit.vue';

    import ComponentAttributes from "../../../components/Attributes.vue";

    export default {
        extends: Edit,
        components:{
            'component-attributes': ComponentAttributes
        },
        data () {
            return {
                resource:{
                    catalog_attributes: []
                },
                config: null,
                options: [],
                attributes: [],
                selection: [],
                paginationOrders: [
                  {id:'order_asc', name:'Manuel (ordre asc)'},
                  {id:'order_desc', name:'Manuel (ordre desc)'},
                  {id:'relevance', name:'Pertinence'},
                  {id:'new', name:'Nouveautés'},
                  {id:'name', name:'Nom'},
                  {id:'rating', name:'Rating'},
                  {id:'price_asc', name:'Prix croissants'},
                  {id:'price_desc', name:'Prix décroissants'}
                ],
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description','headline','meta_url','meta_title','meta_description']);

                if( this.$route.meta.action == "edit" ) {
                    let attributes = [];
                    for (let item of this.resource.catalog_attributes) {
                        attributes.push(item.id);
                    }
                    this.resource.catalog_attributes = attributes
                }

                AttributeService.all().then(response => {
                    this.attributes = []
                    this.selection = []
                    this.isLoading = false

                    for(let item of response.data){
                        console.log(item);
                        if( item.parent_id == null ){
                            this.attributes.push(item);
                        }
                        if( !item.parent_id && this.resource.catalog_attributes.indexOf(item.id) >= 0 ){
                            this.selection.push({id:item.id, name:item.name});
                        }
                    }

                })

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
              this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.localesLoaded = true;
                this.initialize()
            },
            getResource: function(){
                return CategoryService
            },
            beforeUpdate: function(Resource){
                Resource.catalog_attributes = this.selection
                return true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/category/Edit.vue